

module.exports = __webpack_require__.stylable.create(
    "ToggleSwitch3611030838",
    {"classes":{"root":"ToggleSwitch3611030838__root"},"vars":{},"stVars":{"DefaultBaseColor":"\"color(color-5)\"","DefaultSelectedColor":"\"color(color-8)\"","DefaultKnobColor":"\"color(color-1)\"","DefaultDisabledColor":"\"opacity(color(color-3), 0.9)\"","DefaultTransitionDuration":".2s","BaseColor":"--overridable","SelectedColor":"--overridable","KnobColor":"--overridable","DisabledColor":"--overridable","UsedBaseColor":"\"color(fallback(--overridable, color(color-5)))\"","UsedSelectedColor":"\"color(fallback(--overridable, color(color-8)))\"","UsedKnobColor":"\"color(fallback(--overridable, color(color-1)))\"","UsedDisabledColor":"\"color(fallback(--overridable, opacity(color(color-3), 0.9)))\""},"keyframes":{}},
    "",
    7,
    "ToggleSwitch3611030838",
    null
);
